import { IconButton, IconMessage, WithBadge, WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import {
  COMMENTS_PAGE_SIZE,
  WithCommentPopover,
} from '@webapp/platform/comment'
import messages from '../messages'

interface IExpenseCommentPopoverButtonProps {
  contentTypeId: number
  objectId: number
  userId: number
}

export const ExpenseCommentPopoverButton = ({
  contentTypeId,
  objectId,
  userId,
}: IExpenseCommentPopoverButtonProps) => {
  const intl = useProcurifyIntl()

  return (
    <WithCommentPopover
      contentID={contentTypeId}
      objectID={objectId}
      userID={userId}
      pageSize={COMMENTS_PAGE_SIZE}
    >
      {(commentsCount) => (
        <WithTooltip
          title={intl.formatMessage(messages.commentsToolbarButton)}
          placement='bottom'
        >
          <WithTooltip.Wrapper>
            <WithBadge
              content={commentsCount}
              ariaLabel={intl.formatMessage(messages.commentsCountAriaLabel, {
                count: commentsCount,
              })}
            >
              <IconButton
                iconComponent={<IconMessage />}
                aria-label={intl.formatMessage(messages.commentsToolbarButton)}
              />
            </WithBadge>
          </WithTooltip.Wrapper>
        </WithTooltip>
      )}
    </WithCommentPopover>
  )
}

ExpenseCommentPopoverButton.displayName = 'ExpenseCommentPopoverButton'
